import {connect} from 'react-redux';
import {DesignChapter} from '@learningblocks/storybook-components';

import {getHintsData} from './Hint.selector';

function mapStateToProps(state, ownProps) {
  return getHintsData(state);
}

function mapDispatchToProps(dispatch) {
  return {};
}

export const Hint = connect(
  mapStateToProps,
  mapDispatchToProps
)(DesignChapter.Hint);
